<template>
  <div class="list-table">
    <div class="list-table__filter">
      <el-button type="primary" @click="handleAdd">
        新增任务
      </el-button>
    </div>
    <el-table
      v-loading="loading"
      class="list-table__main"
      :data="list"
      border
      highlight-current-row
    >
      <el-table-column
        v-for="(item, index) in TABLE_COLUMN"
        :key="index"
        v-bind="item"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'type'">
            {{ formatLabel(scope.row.type, TYPE_LIST) }}
          </div>
          <div v-else-if="item.prop === 'taskType'">
            {{ formatLabel(scope.row.taskType, TASK_LIST) }}
          </div>
          <div v-else-if="item.prop === 'cyclicType'">
            {{ formatLabel(scope.row.cyclicType, CYCLIC_TYPE_LIST) }}
          </div>
          <div v-else-if="item.prop === 'users'" style="display: flex; align-items: center;">
            {{ handleUser(scope.row.users) }}
            <el-button
              v-if="scope.row.users && scope.row.users.length > 2"
              type="text"
              style="float:right;"
              @click="handleShowUsers(scope.row)"
            >
              查看
            </el-button>
          </div>
          <div v-else-if="item.prop === 'status'">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="ENABLED"
              inactive-value="DISABLED"
              @change="showChangeStatusDialog(scope.row.status, scope.row)"
            />
          </div>
          <div v-else-if="item.prop === 'action'" class="button-space">
            <el-button
              type="text"
              @click="handleEditOrSubscribeOrDetails(scope.row, 'DETAILS')"
            >
              详情
            </el-button>
            <span>|</span>
            <el-button
              :disabled="scope.row.taskType!=='REGULAR'"
              type="text"
              @click="handleEditOrSubscribeOrDetails(scope.row, 'EDIT')"
            >
              编辑
            </el-button>
            <span>|</span>
            <el-button
              type="text"
              @click="handleLog(scope.row)"
            >
              日志
            </el-button>
            <span>|</span>
            <el-button
              type="text"
              @click="handleEditOrSubscribeOrDetails(scope.row, 'SUBSCRIBE')"
            >
              订阅
            </el-button>
          </div>
          <span v-else>
            {{ (item.formatter ? item.formatter(scope.row) : scope.row[item.prop]) || "-" }}
          </span>
        </template>
      </el-table-column>
    </el-table>

    <CatUserDialog
      :is-show="catUser"
      :current="currentRow"
      title="人员"
      @close="catUser=false"
    />

    <FormDialog
      :visible.sync="isFormDialogVisible"
      :mode="dialogMode"
      :current="currentRow"
      :driver-level-options="driverLevelOptions"
      @ok="$emit('refresh')"
    />

    <el-dialog
      v-if="isStatusDialogVisible"
      :title="`${formatLabel(rowStatus, STATUS_LIST)}确认`"
      :visible.sync="isStatusDialogVisible"
      width="30%"
      :before-close="handleCloseStatusDialog"
    >
      <span><i class="el-icon-warning" />确定{{ formatLabel(rowStatus, STATUS_LIST) }}该任务吗？</span>
      <p class="rule-name">
        {{ currentRow.name }}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeStatus(false)">取 消</el-button>
        <el-button
          type="primary"
          :loading="loadingStatus"
          @click="changeStatus(true)"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { popRuleManagementUpsert, popRuleManagementChangeStatus } from '@/api/userControl';
import FormDialog from './FormDialog.vue';
import {
  TABLE_COLUMN, TYPE_LIST, TASK_LIST, CYCLIC_TYPE_LIST, STATUS_LIST,
} from '../constant';
import CatUserDialog from './CatUserDialog.vue';

export default {
  name: 'ListTable',
  components: {
    FormDialog,
    CatUserDialog,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    driverLevelOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      TABLE_COLUMN,
      loading: false,
      dialogMode: '',
      isFormDialogVisible: false,
      currentRow: null,
      isStatusDialogVisible: false,
      rowStatus: null,
      TYPE_LIST,
      TASK_LIST,
      CYCLIC_TYPE_LIST,
      STATUS_LIST,
      loadingStatus: false,
      catUser: false,
    };
  },
  methods: {
    handleShowUsers(row) {
      this.currentRow = row;
      this.catUser = true;
    },
    handleUser(users) {
      if (users?.length > 2) {
        return `${users.slice(0, 2).map((item) => item.bizName).join('、')}等 ${users.length} 人`;
      }
      return users.map((item) => item.bizName).join('、');
    },
    handleLog(row) {
      this.$router.push({
        path: '/userCenter/popRuleManagement/log',
        query: {
          id: row.id,
        },
      });
    },
    formatLabel(val, list) {
      if (!val) return val;
      const [temp] = list.filter((item) => item.value === val);
      if (temp) return temp.label;
      if (val === 'IMMEDIATE_EXECUTION') return '立即执行';
      if (val === 'ONE_TIME') return '一次';
      return temp ? temp.label : val;
    },
    showChangeStatusDialog(status, row) {
      row.status = status === 'ENABLED' ? 'DISABLED' : 'ENABLED';
      this.currentRow = row;
      this.rowStatus = status;
      this.isStatusDialogVisible = true;
    },
    async changeStatus(val) {
      if (val) {
        // 更改状态
        try {
          this.loadingStatus = true;
          await popRuleManagementChangeStatus({ id: this.currentRow.id, status: this.rowStatus });
          this.currentRow.status = this.rowStatus;
          this.$message.success('操作成功');
          this.$emit('refresh');
        } finally {
          this.loadingStatus = false;
        }
      }
      this.handleCloseStatusDialog();
    },
    handleCloseStatusDialog() {
      this.currentRow = null;
      this.rowStatus = null;
      this.isStatusDialogVisible = false;
    },
    handleAdd() {
      this.currentRow = null;
      this.dialogMode = 'ADD';
      this.isFormDialogVisible = true;
    },
    handleEditOrSubscribeOrDetails(row, mode) {
      this.currentRow = row;
      this.dialogMode = mode;
      this.isFormDialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          row.deleteLoading = true;
          popRuleManagementUpsert({ id: row.id });
          this.$message.success('删除成功');
          this.$emit('refresh');
        } finally {
          row.deleteLoading = false;
        }
      });
    },
    getDriverLevelLabel(levels) {
      const res = this.driverLevelOptions.filter((item) => levels.includes(item.code));
      return res.map((item) => item.name).join('、');
    },
  },
};
</script>

<style lang="scss" scoped>
.list-table {
  &__filter {
    margin-bottom: 16px;
  }

  &__main {
    .button-space > *:not(:last-child) {
      margin-right: 8px;
    }
  }
  .list-table__filter{
    text-align: right;
  }
  .button-space > *{
    margin-right:  0px !important;
  }

  .button-space{
    .el-button + .el-button{
    margin-left:  0px !important;
  }
    span{
      margin-left:5px;
      margin-right: 3px !important;
      color: #bcbcbc;
    }
  }
  .el-icon-warning{
    color: red;
    font-size: 18px;
    margin-right: 5px;
  }
  .rule-name{
    color: red;
    margin-left: 22px;
    margin-top: 5px;
  }
}
</style>
